import { Injectable } from '@angular/core';

import { User } from '../models/user.model';
import { ApiConfig } from './config/api.config';
import { CacheService } from '../models/cache-service.model';
import { DataContract } from '../models/data-contract.model';
import { Beneficiary } from '../models/beneficiary.model';
import { AuthService } from './auth.service';
import { Subject } from 'rxjs/Subject';
import { UserManagement } from '../models/user-management.model';

@Injectable()
export class SessionService {

    changeContract : boolean;

    changeContractObservable : Subject<boolean> = new Subject();

    constructor(
        private _authService : AuthService
    ){

    }

    getToken() {

        let _auth = JSON.parse(sessionStorage.getItem('currentUser'));
        if (_auth) {
            return _auth.user.token;
        }
    }

    getTokenManagement(){
        let _auth = this.getCurrentUserManagement(); 
        if(_auth){
            return _auth.token;
        }
        return null;
    }



    getCurrentUser(): User {
        let _user: User;        
        let _obj = JSON.parse(sessionStorage.getItem('currentUser'));
        if (_obj) {
            _user = <User>_obj.user;
        }       
        return _user;
    }

    setCurrentUser(_user: User): void {
        sessionStorage.setItem('currentUser', JSON.stringify({ user: _user }));
    }

    setIdLogin(id:string){
        sessionStorage.setItem('idLogin', id);
    }

    getIdLogin():string{
        return sessionStorage.getItem('idLogin');
    }

    getCurrentUserManagement(): UserManagement{
        let _user: UserManagement;        
        let _obj = JSON.parse(sessionStorage.getItem('currentUserMP'));
        if (_obj) {
            _user = <UserManagement>_obj.user;
        }       
        return _user;
    }

    setCurrentUserManagement(_user : UserManagement) : void{
        sessionStorage.setItem('currentUserMP', JSON.stringify({ user: _user }));
    }

    getCache(): CacheService {
        let _cache: CacheService;        
        let _obj = JSON.parse(sessionStorage.getItem('cache'));
        if (_obj) {
            _cache = <CacheService>_obj.cache;
        }
        return _cache;
    }

    setCache(_cache: CacheService): void {
        sessionStorage.setItem('cache', JSON.stringify({ cache: _cache }));
    }

    getSelectContract(): string{
        let _contract : string;
        let _obj = sessionStorage.getItem('selectContract');
        if (_obj) {
            _contract = _obj;
        }      
        return _contract;
    }

    setSelectContract(_contract : string) : void{
        sessionStorage.setItem('selectContract', _contract);
    }

    getSelectDocumentTypeContracted(): string{
        let _documentTypeContract : string;
        let _obj = sessionStorage.getItem('selectDocumentTypeContract');
        if (_obj) {
            _documentTypeContract = _obj;
        }      
        return _documentTypeContract;
    }

    setSelectDocumentTypeContracted(_documentType : string) : void{
        sessionStorage.setItem('selectDocumentTypeContract', _documentType);
        //console.log(_documentType);
    }

    getDataContract(): DataContract{
        let _dataContract : DataContract;       
        let _obj = JSON.parse(sessionStorage.getItem('dataContract'));
        if (_obj) {
            _dataContract = <DataContract>_obj;
        }       
        return _dataContract;
    }

    setDataContract(_dataContract : DataContract, updateDataFromSession: boolean) : void{
        sessionStorage.setItem('dataContract', JSON.stringify(_dataContract));
        this.changeContract = updateDataFromSession;
        this.changeContractObservable.next(this.changeContract);
    }

    getContracts(): any[]{
        let _contracts : any[];        
        let _obj = JSON.parse(sessionStorage.getItem('contracts'));
        if (_obj) {
            _contracts = <any[]>_obj;
        }       
        return _contracts;
    }

    setContracts(_contracts : any[]) : void {
        sessionStorage.setItem('contracts', JSON.stringify(_contracts));                
    }    

}


// WEBPACK FOOTER //
// /app/src/app/shared/services/session.service.ts